<template>
  <div>
       <el-table
            :data="getTrialScheduleList"
            style="width: 100%">
            
            <el-table-column 
            label="Schedule Date" width="250">
            <template slot-scope="scope">
                <el-date-picker
                    size="small"
                    type="date"
                    :disabled="scope.row.trial_id >0"
                    v-model="scope.row.trial_schedule_date"
                    value-format="yyyy-MM-dd"
                    format="MMM dd yyyy">
                </el-date-picker>
            </template>
            </el-table-column>

            <el-table-column 
            label="Trial Type" width="250">
            <template slot-scope="scope">
                <el-select v-model="scope.row.trial_type_id" size="small">
                    <el-option
                        v-for="(data, index) in $store.getters.getTailoringTrialTypeList"
                        :key="index"
                        :label="data.trial_type"
                        :value="data.id">
                            <span style="float: left;">
                                {{data.trial_type}}
                            </span>                               
                    </el-option>  
                </el-select>
            </template>
            </el-table-column>

            <el-table-column 
            label="Status" align="center">
            <template slot-scope="scope">
                <el-tag v-if="scope.row.id>0" size="small" :type="scope.row.trial_id === 0 ? 'danger' : 'success'">
                    {{scope.row.trial_id === 0 ? 'Pending' : 'Completed'}}
                </el-tag>
            </template>
            </el-table-column>
            
            <el-table-column
                fixed="right"
                label="">
                <template slot-scope="scope">
                    <div style="text-align: right; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
                        <el-tooltip class="item" effect="dark" :content="scope.row.id === 0 ? 'Add' : 'Update'">
                          <a 
                            v-if="($store.getters.getAccessRights.can_add && scope.row.id === 0) || ($store.getters.getAccessRights.can_edit && scope.row.id > 0 && scope.row.trial_id === 0)"
                            @click="$store.dispatch('saveTrialSchedule', scope.row)" style="cursor: pointer; font-size: 16px;">
                            <i :class="scope.row.id === 0 ? 'el-icon-circle-plus' : 'el-icon-document'"></i>
                          </a>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="Delete">
                          <el-popconfirm
                              @confirm="$store.dispatch('removeTrialSchedule', scope.row.id)"
                              title="Are you sure to delete this?"
                              >
                                <a slot="reference" v-if="$store.getters.getAccessRights.can_delete && scope.row.trial_id === 0 && scope.row.id > 0" style="cursor: pointer; margin-left: 10px; color: red; font-size: 16px;">
                                  <i class="el-icon-delete"></i>
                                </a>
                              
                          </el-popconfirm>
                        </el-tooltip>
                        
                    </div>                                        
                </template>
            </el-table-column>
        </el-table>
  </div>
</template>

<script>
export default {
    props: ['selected_list_item_id'],
    computed: {
        getTrialScheduleList() {
            return this.$store.state.saleMaster.trial_schedule_list
        }
    },
    methods: {
        closeNormal() {
            this.changeFocus('sale_net_total_'+this.rowData.key)
            this.$emit('closed')
        },
        closeWindow() {
            this.rowData.fabric_unit_qty = this.rowData.combination_item_list.reduce((count, element1) => {return count + parseFloat(element1.fabric_unit_qty);}, 0).toFixed(2);
            this.changeFocus('sale_net_total_'+this.rowData.key)
            this.$emit('closed')
        }
    },
    mounted() {
        setTimeout(() => {
            this.$store.state.saleMaster.trial_schedule_list = []
            this.$store.dispatch('fetchTrialSchedule', {sale_item_id: this.selected_list_item_id})
        }, 300);
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/SaleMaster/Form/OrderItem/TrialSchedule.vue